import { render } from "./key-recovery.vue?vue&type=template&id=6007be38&scoped=true"
import script from "./key-recovery.vue?vue&type=script&lang=js"
export * from "./key-recovery.vue?vue&type=script&lang=js"

import "./key-recovery.vue?vue&type=style&index=0&id=6007be38&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6007be38"]])

export default __exports__